import React from 'react';
import './App.css';
import CoinFlipper from './CoinFlipper';

function App() {
  return (
    <div className="App">
      <CoinFlipper />
    </div>
  );
}

export default App;
